import { PartialKeys } from "@/lib/ts-helpers/PartialKeys";
import { Link } from "@tanstack/react-router";
import React from "react";
import { App } from "../../../types/app.type";

type PartialApp = PartialKeys<
  App,
  "createdBy" | "name" | "createdAt" | "origin"
>;

type Props = {
  app: PartialApp;
  disableLink?: boolean;
  children: React.ReactNode;
};

function AppLink({ app, disableLink, children }: Props) {
  if (disableLink) {
    return children;
  }

  switch (app.origin) {
    case "public":
      return (
        <a href={app.publicUrl} target="_blank" rel="noreferrer">
          {children}
        </a>
      );

    case "organization":
      return (
        <Link
          className="last:mb-4"
          to="/organization/$organizationSlug/private/$appSlug"
          params={(prev) => ({
            organizationSlug: prev.organizationSlug || "",
            appSlug: app.slug || ""
          })}
        >
          {children}
        </Link>
      );

    case "subscription":
      return (
        <Link
          className="last:mb-4"
          to="/organization/$organizationSlug/subscription/$subscriptionId"
          params={(prev) => ({
            organizationSlug: prev.organizationSlug || "",
            subscriptionId: app.subscription?.id || ""
          })}
        >
          {children}
        </Link>
      );
    default:
      return children;
  }
}

export default AppLink;
